const mainVideo = document.querySelector('.mm-videos-main-video');  // Renommé en mainVideo
const playButtonVideo2 = document.querySelector('.mm-videos-media-play-btn');  // Renommé en playButtonVideo2
const pauseButtonVideo2 = document.querySelector('.mm-videos-media-pause-btn');  // Renommé en pauseButtonVideo2
const smallProductCard = document.querySelector('.mm-produt-card-small-mobile-video');
const videoPcTime = smallProductCard.dataset.time;
const progressBar = document.querySelector(".mm-videos-media-progress-bar");

function updateButtonsVideo2() {
    if (mainVideo.paused) {
        playButtonVideo2.style.display = 'block';
        pauseButtonVideo2.style.display = 'none';
    } else {
        playButtonVideo2.style.display = 'none';
        pauseButtonVideo2.style.display = 'block';
    }
}

function playVideo2() {
    mainVideo.play();
    updateButtonsVideo2();
    progressBar.style.display = 'block';
    
    mainVideo.addEventListener('timeupdate', function() {
        const percentage = Math.floor((100 / mainVideo.duration) * mainVideo.currentTime);
        progressBar.value = percentage;
    });
}

function pauseVideo2() {
    mainVideo.pause();
    updateButtonsVideo2();
}

function togglePlayPauseVideo2() {
    if (mainVideo.paused) {
        playVideo2();
    } else {
        pauseVideo2();
    }
}

mainVideo.addEventListener('play', function() {
    setTimeout(function() {
        smallProductCard.classList.add('mm-visible');
    }, videoPcTime);
    updateButtonsVideo2();
});

mainVideo.addEventListener('pause', updateButtonsVideo2);
mainVideo.addEventListener('ended', updateButtonsVideo2);

playButtonVideo2.addEventListener('click', playVideo2);
pauseButtonVideo2.addEventListener('click', pauseVideo2);

mainVideo.addEventListener('click', togglePlayPauseVideo2);

// Hide preview, play main video
document.addEventListener('DOMContentLoaded', function () {
    var previewVideo = document.querySelector('.mm-videos-preview');
    var mainVideoElement = document.querySelector('.mm-videos-main-video');

    playButtonVideo2.addEventListener('click', function () {
        // Hide preview
        previewVideo.style.display = 'none';
        // Display main video
        mainVideoElement.style.display = 'block';
        // Play main video
        mainVideoElement.play();
    });
});
